(() => {
  'use strict';
  function init(scope = document) {
    const config = scope.querySelector('[data-rl-predictive-config]') || document.querySelector('[data-rl-predictive-config]');
    if (!config) return;
    scope.querySelectorAll('.site-header form[role="search"]').forEach(form => {
      const input = form.querySelector('input[name="q"]');
      if (!input || form.dataset.rlPredictiveReady) return;
      form.dataset.rlPredictiveReady = 'true';
      form.classList.add('rl-predictive-form');
      const panel = document.createElement('div');
      panel.className = 'rl-predictive-panel'; panel.hidden = true;
      const list = document.createElement('ul');
      list.id = `${input.id}-suggestions`; list.className = 'rl-predictive-list';
      list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', config.dataset.label);
      const message = document.createElement('div'); message.className = 'rl-predictive-message';
      const status = document.createElement('span'); status.className = 'visually-hidden';
      status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.setAttribute('aria-atomic', 'true');
      panel.append(list, message); form.append(panel, status);
      input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', list.id); input.setAttribute('aria-expanded', 'false');
      input.setAttribute('autocomplete', 'off');
      let timer, controller, serial = 0, active = -1, choices = [], composing = false;
      const close = () => {
        clearTimeout(timer); serial++; controller?.abort();
        panel.hidden = true; input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant'); active = -1;
        list.querySelectorAll('[aria-selected]').forEach(option => option.setAttribute('aria-selected', 'false'));
      };
      const current = (version, query) => version === serial && input.value.trim() === query && document.activeElement === input && input.getClientRects().length > 0;
      const setActive = index => {
        active = index;
        [...list.children].forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
        const option = list.children[index];
        if (option) { input.setAttribute('aria-activedescendant', option.id); option.scrollIntoView({ block: 'nearest' }); }
      };
      const choose = index => {
        const choice = choices[index]; if (!choice) return;
        input.value = choice.text; close();
        if (choice.productURL) window.location.assign(choice.productURL);
        else form.requestSubmit();
      };
      const render = results => {
        choices = []; const seen = new Set();
        for (const item of (results.queries || []).slice(0, 3)) {
          if (typeof item.text !== 'string' || !item.text.trim()) continue;
          const text = item.text.trim(); const key = text.toLocaleLowerCase();
          if (!seen.has(key)) { seen.add(key); choices.push({ text }); }
        }
        for (const item of (results.products || []).slice(0, 6)) {
          if (typeof item.title !== 'string' || !item.title.trim() || typeof item.url !== 'string') continue;
          let url; try { url = new URL(item.url, location.origin); } catch { continue; }
          if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(url.pathname)) continue;
          const key = url.pathname + url.search;
          if (seen.has(key)) continue; seen.add(key);
          choices.push({ text: item.title.trim(), productURL: url.href });
        }
        list.replaceChildren(); active = -1; input.removeAttribute('aria-activedescendant');
        choices.forEach((choice, index) => {
          const option = document.createElement('li'); option.id = `${list.id}-${index}`;
          option.setAttribute('role', 'option'); option.setAttribute('aria-selected', 'false');
          const title = document.createElement('span'); title.textContent = choice.text;
          const kind = document.createElement('small'); kind.textContent = choice.productURL ? config.dataset.product : config.dataset.query;
          option.append(title, kind);
          option.addEventListener('pointerdown', event => event.preventDefault());
          option.addEventListener('click', () => choose(index)); list.append(option);
        });
        message.hidden = choices.length > 0; message.textContent = config.dataset.empty;
        panel.hidden = false; input.setAttribute('aria-expanded', 'true');
        status.textContent = choices.length ? config.dataset.count.replace('[count]', String(choices.length)) : config.dataset.empty;
      };
      const search = async (query, version) => {
        controller = new AbortController();
        try {
          const url = new URL(config.dataset.url + '.json', location.origin);
          url.search = new URLSearchParams({ q: query, 'resources[type]': 'query,product', 'resources[limit]': '6', 'resources[limit_scope]': 'each', 'resources[options][unavailable_products]': 'show' });
          const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Predictive search unavailable');
          const data = await response.json();
          if (current(version, query)) render(data.resources?.results || {});
        } catch (error) {
          if (current(version, query) && error.name !== 'AbortError') { close(); status.textContent = config.dataset.fallback; }
        }
      };
      const schedule = () => {
        close(); status.textContent = ''; choices = []; const query = input.value.trim();
        if (composing || query.length < 2) return;
        const version = serial; timer = setTimeout(() => search(query, version), 180);
      };
      input.addEventListener('input', schedule);
      input.addEventListener('focus', schedule);
      input.addEventListener('compositionstart', () => { composing = true; close(); });
      input.addEventListener('compositionend', () => { composing = false; schedule(); });
      input.addEventListener('keydown', event => {
        if (composing || event.isComposing) return;
        if (event.key === 'Escape') { if (!panel.hidden) { event.preventDefault(); event.stopPropagation(); } close(); return; }
        if (event.key === 'Tab') { close(); return; }
        if (panel.hidden || !choices.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault(); setActive(event.key === 'ArrowDown' ? (active + 1) % choices.length : (active < 0 ? choices.length - 1 : (active - 1 + choices.length) % choices.length));
        } else if (event.key === 'Enter' && active >= 0) { event.preventDefault(); choose(active); }
      });
      form.addEventListener('submit', close);
      form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) close(); });
      form.closest('details')?.addEventListener('toggle', event => { if (!event.target.open) close(); });
      form.closest('dialog')?.addEventListener('close', close);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
